import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=7193ace0&scoped=true&"
import script from "./Cashback.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Cashback.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Cashback.vue?vue&type=style&index=0&id=7193ace0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7193ace0",
  null
  
)

export default component.exports